/**
 * MatrixHeader — fee & block stats bar shown at top during Matrix mode.
 * Extracted from Index.tsx for maintainability.
 */

import { motion } from 'framer-motion';
import type { NetworkState } from '@/types/game';

interface MatrixHeaderProps {
  network: NetworkState;
}

export default function MatrixHeader({ network }: MatrixHeaderProps) {
  return (
    <motion.div
      data-share-exclude="true"
      className="w-full max-w-sm mx-auto px-3 pt-2.5 pb-0 relative z-10"
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.3 }}
    >
      <p
        className="text-[9px] tabular-nums tracking-wide text-center py-1.5"
        style={{
          fontFamily: 'monospace',
          color: 'rgba(0,255,70,0.55)',
          textShadow: '0 0 8px rgba(0,255,70,0.3)',
        }}
      >
        ⚡ {network.recommendedFees.high} · {network.recommendedFees.medium} · {network.recommendedFees.low} sat/vB &nbsp;│&nbsp; #{network.lastBlockHeight.toLocaleString()}
      </p>
    </motion.div>
  );
}
